export async function textToClipboard(text: string): Promise<void> {
  return navigator.clipboard.writeText(text);
}
